// @ts-nocheck
/* eslint-disable */
import { node, icon } from "~/util/dom";
import PhotoContextMenu from "./photocontextmenu";

window.PhotoMenu = class {
	constructor(data) {
		this._dom = {
			button: node("button", { className: "photocontextbutton", type: "button" }),
			menu: node("div", { className: "ddmenu hidden" }),
			container: node("div", { className: "photocontext" }),
		}

		this._data = Object.assign({
			url: null,
			coords: null,
		}, data)

		this._dom.button.appendChild(icon("etc-vertical"));
		this._dom.container.appendChild(this._dom.button);
		this._dom.button.addEventListener("click", this, false);

		this._menu = new PhotoContextMenu({ closestSelector: "div.photocontext", names: ["reportBad"], parent: this._dom.container, clickCb: itemName => this._itemClick(itemName) });
	}


	get button() {
		return this._dom.container;
	}

	handleEvent(e) {
		if (e.target.closest("button.photocontextbutton")) {
			this._menu.toggle();
		}
	}

	_itemClick(itemName) {
		switch (itemName) {
			case "reportBad":
				Mapy.getComponent("logger").log("click", {
					text: "Nahlasit problem",
					source: "fotky"
				});
				Mapy.BadPhoto.data = this._data;
				Mapy.BadPhoto.open();
		}
	}
}
